import {omit} from 'lodash-es';

import type {BusinessLimit, BusinessLimitField} from '@/types';

import type {LimitAction} from './types';
import {LimitActionType} from './types';

const updateLimitReducer = (state: BusinessLimit, action: LimitAction) => {
  switch (action.type) {
    case LimitActionType.UPDATE_LIMIT:
      return {
        ...state,
        ...action.payload,
      };

    case LimitActionType.UPDATE_TAG: {
      const tagKey = Object.keys(action.payload)?.[0] as BusinessLimitField;
      if (!tagKey) {
        return state;
      }
      return {
        ...state,
        meta: {
          ...(state.meta ?? {}),
          tags: {
            ...(state?.meta?.tags ?? {}),
            ...action.payload,
          },
        },
      };
    }

    case LimitActionType.REMOVE_TAG:
      return {
        ...state,
        meta: {
          ...state?.meta,
          tags: omit(state?.meta?.tags ?? {}, [action.payload]),
        },
      };

    case LimitActionType.ADD_TAG: {
      if (!action.payload) {
        return state;
      }
      const operatorAndValue = Object.values(action.payload)?.[0];
      const [operator, value] = operatorAndValue.split('::');
      if (operator === 'BETWEEN') {
        const values = (value || '')?.split(',');
        if (values?.length !== 2) {
          return state;
        }
      }

      return {
        ...state,
        meta: {
          ...state?.meta,
          tags: {
            ...(state?.meta?.tags ?? {}),
            ...action.payload,
          },
        },
      };
    }

    case LimitActionType.SET_LIMIT_MAP:
      return {
        ...state,
        limit: action.payload || {},
      };
    default:
      return state;
  }
};

export default updateLimitReducer;
